module.exports = __webpack_public_path__ + "static/media/H.E. Dr. Dr. h.c. Raphael Nagel.7161db22.docx";